import React from 'react';
import { Dialog, Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export default function PromotionalBannerModal({ imageUrl, isVisible, onClose }) {
  if (!imageUrl) return null;

  return (
    <Dialog
      open={isVisible}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          backgroundColor: 'transparent',
          boxShadow: 'none',
          position: 'relative',
          overflow: 'visible', 
          mx: { xs: 2, sm: 'auto' } // En móvil, fuerza algo de margen lateral 
        }
      }}
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            backdropFilter: 'blur(2px)' // Toque premium
          }
        }
      }}
    >
      <Box sx={{
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        pt: 4, // Espacio superior para la X
      }}>
        {/* Botón de cierre explícitamente fuera o muy al borde para móvil */}
        <IconButton
          onClick={onClose}
          sx={{
            position: 'absolute',
            top: 0,
            right: 0,
            color: '#fff',
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            backdropFilter: 'blur(4px)',
            zIndex: 10,
            border: '1px solid rgba(255, 255, 255, 0.3)',
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 0.3)'
            }
          }}
        >
          <CloseIcon />
        </IconButton>
        
        <Box
          component="img"
          src={imageUrl}
          alt="Promoción Especial"
          sx={{
            width: '100%',
            maxHeight: '75vh',
            objectFit: 'contain',
            borderRadius: '16px',
            boxShadow: '0 12px 40px rgba(0,0,0,0.4)',
            // Para asegurar que en resoluciones grandes no crezca infinitamente
            maxWidth: '100%' 
          }}
        />
      </Box>
    </Dialog>
  );
}
